// extracted by mini-css-extract-plugin
export default {"infoItem":"InfoItem_infoItem__5FjwD"};